var NUMBER_OF_COLUMNS = /* @__PURE__ */ ((NUMBER_OF_COLUMNS2) => {
  NUMBER_OF_COLUMNS2[NUMBER_OF_COLUMNS2["FREE_FLOW"] = 0] = "FREE_FLOW";
  NUMBER_OF_COLUMNS2[NUMBER_OF_COLUMNS2["ONE"] = 1] = "ONE";
  NUMBER_OF_COLUMNS2[NUMBER_OF_COLUMNS2["TWO"] = 2] = "TWO";
  NUMBER_OF_COLUMNS2[NUMBER_OF_COLUMNS2["THREE"] = 3] = "THREE";
  return NUMBER_OF_COLUMNS2;
})(NUMBER_OF_COLUMNS || {});
export {
  NUMBER_OF_COLUMNS
};
//# sourceMappingURL=options-layout-constants.js.map
